import React, { useState } from 'react';
import Nav from '@/components/tos/desktop/Nav';
import { ContentSection, menu, normalizeForAnchor } from '@/constants/tos';
import { Card } from '@/components/shadcn/card';
import Content from './Content';

interface Props {
  data: {
    title: string;
    date: string;
    sections: ContentSection[];
  };
  sections: ContentSection[];
  page?: string;
}

export default function Desktop({ data, sections, page }: Props) {
  const [currentContent, setCurrentContent] = useState<string | null>(null);

  return (
    <div className="hidden md:block">
      <Nav menu={menu} page={page} />
      <div className="z-0 mx-auto mt-10 flex max-w-xl gap-10 pb-10">
        <Card className="sticky top-[calc(var(--header-height))] z-0 flex shrink-0 basis-[420px] flex-col gap-6 self-start border border-neutral-700 bg-neutral-800 shadow-none md:p-6">
          <div className="px-1 text-neutral-400">
            <p>Last Updated: {data.date}</p>
          </div>
          <ul className="flex flex-col gap-3">
            {sections.map(item => {
              return (
                <div
                  data-active={currentContent === item.title}
                  className="cursor-pointer text-neutral-300 hover:text-brand data-[active=true]:text-azure-700"
                  key={item.title}>
                  <a
                    href={`#${normalizeForAnchor(item.title)}`}
                    className="font-lato font-normal leading-none">
                    {item.title}
                  </a>
                </div>
              );
            })}
          </ul>
        </Card>
        <Content
          data={data}
          setCurrentContent={setCurrentContent}
          page={page}
        />
      </div>
    </div>
  );
}
